import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { NotificationService } from '../services/notification.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ConfigEntry, ConfigStatus, CradleCommands } from '../constants/constants';
import { MatSliderModule } from '@angular/material/slider';
import { CradleService } from '../services/cradle.service';
import { IMqttMessage } from 'ngx-mqtt';
import { Utils } from '../constants/utils';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatSliderModule
    ]
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  changePasswordForm: FormGroup;
  isLoading = false;
  hideCurrentPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  public CradleCommands = CradleCommands;
  private configChanged: Subject<ConfigEntry> = new Subject<ConfigEntry>();
  configStatus: ConfigStatus = new ConfigStatus();
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private notificationService: NotificationService,
    private router: Router,
    private cradleService: CradleService
  ) {
    this.changePasswordForm = this.fb.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit(){
    this.subscriptions.push(this.cradleService
      .listenToConfigStatus()
      .subscribe((message: IMqttMessage) => {
        this.configStatus = Utils.mapPayloadToConfigStatus(message.payload.toString());
      }));
      setTimeout(()=>{
        this.cradleService.dispatchCommand(CradleCommands.PUBLISH_CONFIG_STATUS);
      },500)

      this.subscriptions.push(
        this.configChanged.pipe(debounceTime(1000)).subscribe(config=>
          this.dispatchAction(config.command, config.value))
      );
  }

  dispatchAction(command:CradleCommands, value:number){
    this.cradleService.dispatchCommand(
      command,
      value
    );
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('newPassword').value === g.get('confirmPassword').value
      ? null : { mismatch: true };
  }

  onSubmit() {
    if (this.changePasswordForm.valid) {
      this.isLoading = true;
      const { currentPassword, newPassword } = this.changePasswordForm.value;

      this.apiService.changePassword(currentPassword, newPassword).subscribe({
        next: () => {
          this.notificationService.success('Password changed successfully');
          this.router.navigate(['/']);
        },
        error: (error) => {
          this.isLoading = false;
          this.notificationService.error(error.error?.message || 'Failed to change password');
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }

  preventDecimal(event: KeyboardEvent): void{
    if( event.key === '.' || event.key === 'Decimal'){
      event.preventDefault();
    }
  }

  updateConfig(command:CradleCommands, value:number){
      this.configChanged.next({command,value});
    }

    ngOnDestroy(): void {
      this.subscriptions.forEach(sub=> sub.unsubscribe())
    }


}
